import React, {useEffect, useRef, useState} from "react"

import "./MyPage.css"
import iconBack from "../../assets/iconBack.svg"

import MyNav from "../../component/Nav/MyNav"
import RightFooter from "../../component/Footer/RightFooter"
import {dateToString, getDateTimeStr, numberWithCommas, numberWoCommas, sendRequest} from "../../common";
import ReactToPrint from "react-to-print";
import {
	Table,
	Modal, Button,
} from "antd";

function MyOrder() {

	const [payments, setPayments] = useState([])

	const [receiptModalVisible, setReceiptModalVisible] = useState(false)
	const [targetPayment, setTargetPayment] = useState()

	const getPayments = () => {
		sendRequest('order/payment/?isMy=1', 'GET', null, data => {
			setPayments(data)
		})
	}

	useEffect(() => {
		getPayments()
	}, [])

	const printRef = useRef();

	return (
		<>
			<MyNav />
			<div className="container">
				<div className="myContent">
					<div className="header">
						<button type="button">
							<img src={iconBack} alt="뒤로가기" />
						</button>
						<h3>주문내역</h3>
					</div>
					<div className="myWrap">
						<section className="myOrder">
							<span className="tableCount">총 {payments?.length}건</span>
							<div className="myTableWrap">
								<table className="myTable">
									<colgroup>
										<col width="15%" />
										<col width="20%" />
										<col width="30%" />
										<col width="11%" />
										<col width="10%" />
										<col width="7%" />
										<col width="7%" />
									</colgroup>
									<thead>
										<tr>
											<th>주문일자</th>
											<th>주문번호</th>
											<th>주문상품</th>
											<th>주문총액</th>
											<th>결제상황</th>
											<th>매출전표</th>
											<th>처리상황</th>
										</tr>
									</thead>
									<tbody>
										{payments?.map((item, index) => {
											return (
												<tr>
													<td>{getDateTimeStr(new Date(item?.createdDate))}</td>
													<td className="orderNumber">{item?.order?.orderNumber}</td>
													<td className="alignLt">{item?.order?.orderProducts?.map(item => item?.product?.name).toString()}</td>
													<td>{numberWithCommas(item?.price)}원</td>
													<td className="complete">{item?.order?.status}</td>
													<td>
														<button type="button" className="download"
															onClick={() => {
																window.open(`https://iniweb.inicis.com/DefaultWebApp/mall/cr/cm/mCmReceipt_head.jsp?noTid=${item?.paymentNumber}&noMethod=1`)
																// setTargetPayment(item)
																// setReceiptModalVisible(true)
															}}
														>
															다운로드
														</button>
													</td>
													<td className="complete">{item?.resultCode === 'paid' ? '처리완료': '처리대기'}</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>
						</section>
					</div>
				</div>
			</div>
			<RightFooter />
			<Modal
				width={1000}
				title="매출전표"
				visible={receiptModalVisible}
				onOk={() => {
					setReceiptModalVisible(false);
				}}
				onCancel={() => {
					setReceiptModalVisible(false);
				}}
				footer={[
					<Button
						key="back"
						onClick={(e) => {
							e.preventDefault();
							setReceiptModalVisible(false);
						}}
					>
						닫기
					</Button>,
					<ReactToPrint
						trigger={() => <Button type="primary">주문서 출력</Button>}
						content={() => printRef.current}
					/>,
				]}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						padding: "20px",
					}}
					ref={printRef}
				>
					<div
						style={{
							fontSize: "24px",
							fontWeight: 700,
						}}
					>
						인컬리지
					</div>
					<div
						style={{
							marginBottom: "20px",
						}}
					>
						https://hcpts.net/
					</div>
					<div>
            <span
							style={{
								fontWeight: 700,
							}}
						>
              주문번호
            </span>{" "}
						{targetPayment?.order?.orderNumber}
					</div>
					<div>
            <span
							style={{
								fontWeight: 700,
							}}
						>
              주문일자
            </span>{" "}
						{dateToString(targetPayment?.createdDate)}
					</div>
					<div>
            <span
							style={{
								fontWeight: 700,
							}}
						>
              결제수단
            </span>{" "}
						{targetPayment?.type}
					</div>
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							margin: "20px 0",
						}}
					>
						{/*<div>*/}
						{/*	<div*/}
						{/*		style={{*/}
						{/*			fontWeight: 700,*/}
						{/*		}}*/}
						{/*	>*/}
						{/*		배송정보*/}
						{/*	</div>*/}
						{/*	<div>*/}
						{/*		<div>*/}
						{/*			{targetPayment?.address} {targetPayment?.addressDetail}{" "}*/}
						{/*			{targetPayment?.zipCode}*/}
						{/*		</div>*/}
						{/*		<div>{targetPayment?.phone}</div>*/}
						{/*		<div>수취인명: {targetPayment?.name}</div>*/}
						{/*	</div>*/}
						{/*</div>*/}
						<div>
							<div
								style={{
									fontWeight: 700,
								}}
							>
								주문자 정보
							</div>
							<div>
								<div>{targetPayment?.user?.name}</div>
								<div>{targetPayment?.user?.email}</div>
								<div>{targetPayment?.user?.phone}</div>
							</div>
						</div>
					</div>
					<div
						style={{
							fontWeight: 700,
						}}
					>
						주문내역
					</div>
					<div>
						<Table
							pagination={false}
							loading={false}
							columns={[
								{
									title: "상품명",
									render: (val) => {
										return <div>{val?.product?.name}</div>;
									},
								},
								{
									title: "주문상태",
									render: (val) => {
										return <div>{targetPayment?.order?.status}</div>;
									},
								},
								{
									title: "수량",
									render: (val) => {
										return <div>{val?.quantity}</div>;
									},
								},
								{
									title: "단가",
									render: (val) => {
										return (
											<div>{numberWithCommas(val?.product?.price)}원</div>
										);
									},
								},
								{
									title: "소계",
									render: (val) => {
										return (
											<div>
												{numberWithCommas(val.product?.price * val.quantity)}원
											</div>
										);
									},
								},
							]}
							dataSource={targetPayment?.order?.orderProducts}
						/>
					</div>
					<div
						style={{
							flex: 1,
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
							marginTop: "10px",
						}}
					>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								width: "40%",
							}}
						>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}
							>
								<div>합계</div>
								<div>
									{numberWithCommas(
										targetPayment?.order?.orderProducts
											?.map(
												(i) => i.quantity * numberWoCommas(i.product?.price)
											)
											?.reduce(
												(accumulator, currentValue) =>
													accumulator + currentValue,
												0
											)
									)}
								</div>
							</div>
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									fontWeight: 700,
								}}
							>
								<div>결제금액</div>
								<div>{numberWithCommas(targetPayment?.price)}</div>
							</div>
						</div>
					</div>
				</div>
			</Modal>
		</>
	)
}

export default MyOrder
